module.exports = __webpack_public_path__ + "img/alter-ego_en.10e8506.jpg";